import {CSSProperties, FC} from 'react';


export interface IIconSeatHeatProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconSeatHeat: FC<IIconSeatHeatProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path d="M19.418 3h-1.477c-.872 0-1.582.71-1.582 1.582v1.477c0 .378.134.726.357.999a2.03 2.03 0 0 0-.63.932l-2.575 7.307-1.813-.134a1.894 1.894 0 0 1 .369-2.071l.601.6v-1.938h-1.939l.592.592a2.946 2.946 0 0 0-.758 2.733l-1.649-.122a1.892 1.892 0 0 1 .446-1.865l.6.6v-1.938H8.023l.592.592a2.943 2.943 0 0 0-.798 2.53l-1.659-.122a1.89 1.89 0 0 1 .496-1.662l.6.6v-1.938H5.316l.592.592a2.94 2.94 0 0 0-.82 2.358A2.287 2.287 0 0 0 3 16.98V21h15.074l1.894-11.8a2.008 2.008 0 0 0-.19-1.601A1.584 1.584 0 0 0 21 6.059V4.582C21 3.71 20.29 3 19.418 3Zm-.466 5.919-.013.038-1.763 10.988H4.055V16.98c0-.354.145-.68.408-.916.258-.232.59-.341.935-.31.135.264.313.512.534.732.358.359.555.835.555 1.343 0 .507-.199.985-.558 1.344l.746.746a2.94 2.94 0 0 0 .867-2.09 2.93 2.93 0 0 0-.754-1.971l1.436.106c.116.185.254.361.415.522.358.359.555.835.555 1.343 0 .507-.198.985-.558 1.344l.746.746a2.94 2.94 0 0 0 .867-2.09 2.93 2.93 0 0 0-.579-1.758l1.406.104c.082.108.171.212.27.311.358.359.556.835.555 1.343 0 .507-.198.985-.558 1.344l.746.746a2.94 2.94 0 0 0 .867-2.09c0-.555-.152-1.087-.437-1.547l1.719.127 2.845-8.075.005-.014a.976.976 0 0 1 .932-.68.97.97 0 0 1 .79.403.97.97 0 0 1 .142.876Zm.993-2.86c0 .29-.236.527-.527.527h-1.477a.528.528 0 0 1-.527-.527V4.582c0-.29.237-.527.527-.527h1.477c.29 0 .527.236.527.527v1.477Z" />
        </svg>
    );
};
